export const firebase = {
    apiKey: "AIzaSyAbkXiwwS2gSFCOEytxx42oJRXE9gCLfgE",
    authDomain: "eng360-ssbu.firebaseapp.com",
    databaseURL: "https://eng360-ssbu.firebaseio.com",
    projectId: "eng360-ssbu",
    storageBucket: "eng360-ssbu.appspot.com",
    messagingSenderId: "508971051299",
    appId: "1:508971051299:web:cea29a513954520758c496"
  };


export const reduxFirebase = {}
export const env = 'prod'